import { ff } from '@atlassian/jira-feature-flagging';
import { functionWithCondition } from '../function-with-condition/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const functionWithFF = <Fn extends (...args: any[]) => any>(
	featureFlagName: string,
	functionTrue: Fn,
	functionFalse: Fn,
) => functionWithCondition(() => ff(featureFlagName), functionTrue, functionFalse);
